export const baseDistribution = {
  chainRecipients: [],
  inventoryOwner: null,
  locationId: null,
  reconsignmentControl: false,
  shipmentChain: false,
  volume: null,
  volumeDisplay: '',
};

// step 1
export const initialDistributionDetailsState = {
  distributions: [baseDistribution],
};

// step 2
export const initialDistributionSummaryState = {
  distributions: [baseDistribution],
};

export const emptyDistributionDetailsState = {
  distributions: [],
};
